import React from 'react';
import { FaWhatsapp, FaFacebook, FaTwitter } from 'react-icons/fa';
import { FiLink, FiShare2 } from 'react-icons/fi';

const SocialShare = ({ title, text, url = window.location.href }) => {
  const encodedText = encodeURIComponent(`${title} - ${text}`);
  const encodedUrl = encodeURIComponent(url);

  const handleCopy = () => {
    navigator.clipboard.writeText(`${title}: ${text} - ${url}`);
    // Optional: Add a toast notification here if desired
  };

  return (
    <div className="flex items-center justify-center gap-4 mt-3 pt-3 border-t border-gray-100/10 w-full">
      <span className="text-[10px] text-gray-500 uppercase font-bold tracking-widest flex items-center gap-1">
        <FiShare2 /> Share
      </span>
      <div className="flex gap-3">
        <a
          href={`https://wa.me/?text=${encodedText}%20${encodedUrl}`}
          target="_blank"
          rel="noreferrer"
          className="text-gray-400 hover:text-green-500 transition-colors"
          title="Share on WhatsApp"
        >
          <FaWhatsapp size={16} />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noreferrer"
          className="text-gray-400 hover:text-blue-600 transition-colors"
          title="Share on Facebook"
        >
          <FaFacebook size={16} />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`}
          target="_blank"
          rel="noreferrer"
          className="text-gray-400 hover:text-sky-400 transition-colors"
          title="Share on X"
        >
          <FaTwitter size={16} />
        </a>
        <button
          onClick={handleCopy}
          className="text-gray-400 hover:text-white transition-colors"
          title="Copy Link"
        >
          <FiLink size={16} />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;